//refer to
//https://hello.atlassian.net/wiki/spaces/CASRAQ/pages/2821410030/Spike+Spec+Basic+Question+Detection+Integration+in+the+FE

import { languagesWithSpaces } from './languages-with-spaces';
import { languagesWithoutSpaces } from './languages-without-spaces';
import { questionWords } from './question-words';

type isQuestionArgs = {
	query: string;
	locale: string;
};

export const isQuestion = ({ query, locale }: isQuestionArgs): boolean => {
	const language = locale.split('-')[0].toLowerCase();
	const queryWords = query.split(' ');
	const endsWithAQuestionMark = query.endsWith('?');
	const isLanguageWithSpaces = languagesWithSpaces.includes(language);
	const isLanguageWithoutSpaces = languagesWithoutSpaces.includes(language);
	const isLanguageSupported = isLanguageWithSpaces || isLanguageWithoutSpaces;

	if (isLanguageSupported && endsWithAQuestionMark && queryWords.length > 1) {
		return true;
	}

	if (isLanguageWithSpaces) {
		const languageQuestionWords = questionWords[language];
		return (
			queryWords.some((queryWord) =>
				languageQuestionWords.includes(queryWord.toLocaleLowerCase(locale)),
			) && queryWords.length > 1
		);
	}

	if (isLanguageWithoutSpaces) {
		const languageQuestionWords =
			language === 'zh' ? questionWords[locale.toLowerCase()] : questionWords[language];
		return (
			languageQuestionWords.some((questionWord) => query.includes(questionWord)) && query.length > 1
		);
	}

	return false;
};
